export enum ActionType {
  // Clerk Auth
  CLERK_AUTHENTICATION_INIT = "CLERK_AUTHENTICATION_INIT",
  CLERK_AUTHENTICATION_SUCCESS = "CLERK_AUTHENTICATION_SUCCESS",
  CLERK_AUTHENTICATION_FAIL = "CLERK_AUTHENTICATION_FAIL",

  //Verify User
  VERIFY_USER_INIT = "VERIFY_USER_INIT",
  VERIFY_USER_SUCCESS = "VERIFY_USER_SUCCESS",
  VERIFY_USER_FAIL = "VERIFY_USER_FAIL",
  // email
  SEND_EMAIL_OTP_INIT = "SEND_EMAIL_OTP_INIT",
  SEND_EMAIL_OTP_SUCCESS = "SEND_EMAIL_OTP_SUCCESS",
  SEND_EMAIL_OTP_FAIL = "SEND_EMAIL_OTP_FAIL",

  VERIFY_EMAIL_OTP_INIT = "VERIFY_EMAIL_OTP_INIT",
  VERIFY_EMAIL_OTP_SUCCESS = "VERIFY_EMAIL_OTP_SUCCESS",
  VERIFY_EMAIL_OTP_FAIL = "VERIFY_EMAIL_OTP_FAIL",

  USER_EMAIL_LOGIN_INIT = "USER_EMAIL_LOGIN_INIT",
  USER_EMAIL_LOGIN_SUCCESS = "USER_EMAIL_LOGIN_SUCCESS",
  USER_EMAIL_LOGIN_FAIL = "USER_EMAIL_LOGIN_FAIL",

  PUT_DETAILS_EMAIL_INIT = "PUT_DETAILS_EMAIL_INIT",
  PUT_DETAILS_EMAIL_SUCCESS = "PUT_DETAILS_EMAIL_SUCCESS",
  PUT_DETAILS_EMAIL_FAIL = "PUT_DETAILS_EMAIL_FAIL",

  LOGIN_WITH_EMAIL_INIT = "LOGIN_WITH_EMAIL_INIT",
  LOGIN_WITH_EMAIL_SUCCESS = "LOGIN_WITH_EMAIL_SUCCESS",
  LOGIN_WITH_EMAIL_FAIL = "LOGIN_WITH_EMAIL_FAIL",

  // phone

  SEND_PHONE_OTP_INIT = "SEND_PHONE_OTP_INIT",
  SEND_PHONE_OTP_SUCCESS = "SEND_PHONE_OTP_SUCCESS",
  SEND_PHONE_OTP_FAIL = "SEND_PHONE_OTP_FAIL",

  VERIFY_PHONE_OTP_INIT = "VERIFY_PHONE_OTP_INIT",
  VERIFY_PHONE_OTP_SUCCESS = "VERIFY_PHONE_OTP_SUCCESS",
  VERIFY_PHONE_OTP_FAIL = "VERIFY_PHONE_OTP_FAIL",

  PUT_DETAILS_PHONE_INIT = "PUT_DETAILS_PHONE_INIT",
  PUT_DETAILS_PHONE_SUCCESS = "PUT_DETAILS_PHONE_SUCCESS",
  PUT_DETAILS_PHONE_FAIL = "PUT_DETAILS_PHONE_FAIL",

  //not implemented
  SEND_LOGIN_OTP_INIT = "SEND_LOGIN_OTP_INIT",
  SEND_LOGIN_OTP_SUCCESS = "SEND_LOGIN_OTP_SUCCESS",
  SEND_LOGIN_OTP_FAIL = "SEND_LOGIN_OTP_FAIL",

  LOGIN_WITH_PHONE_INIT = "LOGIN_WITH_PHONE_INIT",
  LOGIN_WITH_PHONE_SUCCESS = "LOGIN_WITH_PHONE_SUCCESS",
  LOGIN_WITH_PHONE_FAIL = "LOGIN_WITH_PHONE_FAIL",

  USER_LOGOUT = "USER_LOGOUT",

  //generate story
  GENERATE_STORY_INIT = "GENERATE_STORY_INIT",
  GENERATE_STORY_SUCCESS = "GENERATE_STORY_SUCCESS",
  GENERATE_STORY_FAIL = "GENERATE_STORY_FAIL",

  //cancel generate story
  CANCEL_STORY_INIT = "CANCEL_STORY_INIT",
  CANCEL_STORY_SUCCESS = "CANCEL_STORY_SUCCESS",
  CANCEL_STORY_FAIL = "CANCEL_STORY_FAIL",

  //delete/remove story
  DELETE_STORY_INIT = "DELETE_STORY_INIT",
  DELETE_STORY_SUCCESS = "DELETE_STORY_SUCCESS",
  DELETE_STORY_FAIL = "DELETE_STORY_FAIL",

  //get single story
  GET_SINGLE_STORY_INIT = "GET_SINGLE_STORY_INIT",
  GET_SINGLE_STORY_SUCCESS = "GET_SINGLE_STORY_SUCCESS",
  GET_SINGLE_STORY_FAIL = "GET_SINGLE_STORY_FAIL",

  //get all stories of single user
  GET_ALL_STORY_INIT = "GET_ALL_STORY_INIT",
  GET_ALL_STORY_SUCCESS = "GET_ALL_STORY_SUCCESS",
  GET_ALL_STORY_FAIL = "GET_ALL_STORY_FAIL",

  //user actions
  GET_USER_PROFILE_INIT = "GET_USER_PROFILE_INIT",
  GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS",
  GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL",

  UPDATE_USER_PROFILE_INIT = "UPDATE_USER_PROFILE_INIT",
  UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS",
  UPDATE_USER_PROFILE_FAIL = "UPDATET_USER_PROFILE_FAIL",

  // reset password send actions
  RESET_PASSWORD_SEND_INIT = "RESET_PASSWORD_SEND_INIT",
  RESET_PASSWORD_SEND_SUCCESS = "RESET_PASSWORD_SEND_SUCCESS",
  RESET_PASSWORD_SEND_FAIL = "RESET_PASSWORD_SEND_FAIL",

  // reset password confirm actions
  RESET_PASSWORD_INIT = "RESET_PASSWORD_INIT",
  RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL",

  //feedback
  FEEDBACK_SUBMIT_INIT = "FEEDBACK_SUBMIT_INIT",
  FEEDBACK_SUBMIT_SUCCESS = "FEEDBACK_SUBMIT_SUCCESS",
  FEEDBACK_SUBMIT_FAIL = "FEEDBACK_SUBMIT_FAIL",

  //story created
  STORY_CREATED_INIT = "STORY_CREATED_INIT",
  STORY_CREATED_SUCCESS = "STORY_CREATED_SUCCESS",
  STORY_CREATED_FAIL = "STORY_CREATED_FAIL",

  //interested modal
  INTEREST_MODAL_SUBMIT_INIT = "INTEREST_MODAL_SUBMIT_INIT",
  INTEREST_MODAL_SUBMIT_SUCCESS = "INTEREST_MODAL_SUBMIT_SUCCESS",
  INTEREST_MODAL_SUBMIT_FAIL = "INTEREST_MODAL_SUBMIT_FAIL",

  //Edit story caption
  EDIT_CAPTION_INIT = "EDIT_CAPTION_INIT",
  EDIT_CAPTION = "EDIT_CAPTION",
  EDIT_CAPTION_FAIL = "EDIT_CAPTION_FAIL",

  //Get current plan
  GET_CURRENT_PLAN_INIT = "GET_CURRENT_PLAN_INIT",
  GET_CURRENT_PLAN_SUCCESS = "GET_CURRENT_PLAN_SUCCESS",
  GET_CURRENT_PLAN_FAIL = "GET_CURRENT_PLAN_FAIL",

  //Get current plan
  GET_UPCOMING_PLAN_INIT = "GET_UPCOMING_PLAN_INIT",
  GET_UPCOMING_PLAN_SUCCESS = "GET_UPCOMING_PLAN_SUCCESS",
  GET_UPCOMING_PLAN_FAIL = "GET_UPCOMING_PLAN_FAIL",

  //generate image
  GENERATE_IMAGE_INIT = "GENERATE_IMAGE_INIT",
  GENERATE_IMAGE_SUCCESS = "GENERATE_IMAGE_SUCCESS",
  GENERATE_IMAGE_FAIL = "GENERATE_IMAGE_FAIL",

  //delete/remove image
  DELETE_IMAGE_INIT = "DELETE_IMAGE_INIT",
  DELETE_IMAGE_SUCCESS = "DELETE_IMAGE_SUCCESS",
  DELETE_IMAGE_FAIL = "DELETE_IMAGE_FAIL",

  //get single image
  GET_SINGLE_IMAGE_INIT = "GET_SINGLE_IMAGE_INIT",
  GET_SINGLE_IMAGE_SUCCESS = "GET_SINGLE_IMAGE_SUCCESS",
  GET_SINGLE_IMAGE_FAIL = "GET_SINGLE_IMAGE_FAIL",

  //get all images of single user
  GET_ALL_IMAGE_INIT = "GET_ALL_IMAGE_INIT",
  GET_ALL_IMAGE_SUCCESS = "GET_ALL_IMAGE_SUCCESS",
  GET_ALL_IMAGE_FAIL = "GET_ALL_IMAGE_FAIL",

  //EDIT IMAGE CAPTION
  EDIT_IMAGE_CAPTION_INIT = "EDIT_IMAGE_CAPTION_INIT",
  EDIT_IMAGE_CAPTION_SUCCESS = "EDIT_IMAGE_CAPTION_SUCCESS",
  EDIT_IMAGE_CAPTION_FAIL = "EDIT_IMAGE_CAPTION_FAIL",

  //CANCEL GENERATE IMAGE
  CANCEL_IMAGE_INIT = "CANCEL_IMAGE_INIT",
  CANCEL_IMAGE_SUCCESS = "CANCEL_IMAGE_SUCCESS",
  CANCEL_IMAGE_FAIL = "CANCEL_IMAGE_FAIL",

  RESET_STORY_MESSAGE = "RESET_STORY_MESSAGE",

  //GENERATE LESSON PLAN
  GENERATE_LESSON_PLAN_INIT = "GENERATE_LESSON_PLAN_INIT",
  GENERATE_LESSON_PLAN_SUCCESS = "GENERATE_LESSON_PLAN_SUCCESS",
  GENERATE_LESSON_PLAN_FAIL = "GENERATE_LESSON_PLAN_FAIL",

  //GET ALL LESSON PLANS
  GET_ALL_LESSON_PLAN_INIT = "GET_ALL_LESSON_PLAN_INIT",
  GET_ALL_LESSON_PLAN_SUCCESS = "GET_ALL_LESSON_PLAN_SUCCESS",
  GET_ALL_LESSON_PLAN_FAIL = "GET_ALL_LESSON_PLAN_FAIL",

  //DELETE LESSON PLAN
  DELETE_LESSON_PLAN_INIT = "DELETE_LESSON_PLAN_INIT",
  DELETE_LESSON_PLAN_SUCCESS = "DELETE_LESSON_PLAN_SUCCESS",
  DELETE_LESSON_PLAN_FAIL = "DELETE_LESSON_PLAN_FAIL",

  //LESSONPLAN FEEDBACK
  LESSONPLAN_FEEDBACK_SUBMIT_INIT = "LESSONPLAN_FEEDBACK_SUBMIT_INIT",
  LESSONPLAN_FEEDBACK_SUBMIT_SUCCESS = "LESSONPLAN_FEEDBACK_SUBMIT_SUCCESS",
  LESSONPLAN_FEEDBACK_SUBMIT_FAIL = "LESSONPLAN_FEEDBACK_SUBMIT_FAIL",

  GET_ALL_LESSON_PLAN_V2_INIT = "GET_ALL_LESSON_PLAN_V2_INIT",
  GET_ALL_LESSON_PLAN_V2_SUCCESS = "GET_ALL_LESSON_PLAN_V2_SUCCESS",
  GET_ALL_LESSON_PLAN_V2_FAIL = "GET_ALL_LESSON_PLAN_V2_FAIL",

  SUBMIT_CONTACT_INIT = "SUBMIT_CONTACT_INIT",
  SUBMIT_CONTACT_SUCCESS = "SUBMIT_CONTACT_SUCCESS",
  SUBMIT_CONTACT_FAIL = "SUBMIT_CONTACT_FAIL",

  //APPROVE REGENERATED STORY
  APPROVE_REGENERATED_STORY_INIT = "APPROVE_REGENERATED_STORY_INIT",
  APPROVE_REGENERATED_STORY_SUCCESS = "APPROVE_REGENERATED_STORY_SUCCESS",
  APPROVE_REGENERATED_STORY_FAIL = "APPROVE_REGENERATED_STORY_FAIL",

  //UPDATE REGENERATEd STORY SLIDE
  UPDATE_REGENERATED_CONTENT="UPDATE_REGENERATED_CONTENT",

  //SUBMIT TESTIMONIAL
  SUBMIT_TESTIMONIAL_INIT = "SUBMIT_TESTIMONIAL_INIT",
  SUBMIT_TESTIMONIAL_SUCCESS = "SUBMIT_TESTIMONIAL_SUCCESS",
  SUBMIT_TESTIMONIAL_FAIL = "SUBMIT_TESTIMONIAL_FAIL",
}